<section class="flex mt-2 sm:mt-4 w-screen py-2">
  <div
    id="main-content"
    class="flex w-full max-w-7xl h-auto justify-center items-start mx-auto no-scrollbar overflow-y-scroll"
  >
    <router-outlet />
  </div>
</section>
